/** Flip to true when the hardcover can ship. Mirror in supabase/functions/create-checkout (BOOK_SALES_OPEN). */
export const SALES_OPEN = false;
export const RELEASE_CTA = "Join the release list";
